(() => {
  let animationFrame;

  function getOuterSlide(gallery, carousel) {
    let outer = null;
    let el = gallery.parentElement;
    while (el && el !== carousel) {
      if (el.tagName.toLowerCase() === 'slideshow-slide') outer = el;
      el = el.parentElement;
    }
    return outer;
  }

  function update() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const imageHeight = isMobile ? 280 : 420;

    document.querySelectorAll('product-recommendations').forEach((section) => {
      const carousel = section.querySelector('.resource-list__carousel');
      if (!carousel) return;

      carousel
        .querySelectorAll('.card-gallery[data-image-ratio="adapt"]')
        .forEach((gallery) => {
          const ratio = parseFloat(
            getComputedStyle(gallery).getPropertyValue('--gallery-aspect-ratio')
          );
          if (!Number.isFinite(ratio) || ratio <= 0) return;

          const slide = getOuterSlide(gallery, carousel);
          if (!slide) return;

          const width = Math.round(imageHeight * ratio);
          const set = (k, v) => slide.style.setProperty(k, v, 'important');

          set('--slide-width', `${width}px`);
          set('--slide-width-max', `${width}px`);
          set('width', `${width}px`);
          set('min-width', `${width}px`);
          set('max-width', `${width}px`);
          set('flex', `0 0 ${width}px`);

          gallery.style.setProperty('width', '100%', 'important');

          gallery.querySelectorAll('.product-media-container').forEach((media) => {
            media.style.setProperty('--product-media-fit', 'contain', 'important');
          });
        });
    });
  }

  function scheduleUpdate() {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(update);
  }

  function start() {
    scheduleUpdate();
    new MutationObserver(scheduleUpdate).observe(document.body, {
      childList: true,
      subtree: true,
    });
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    setTimeout(scheduleUpdate, 500);
    setTimeout(scheduleUpdate, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();